<template>
  <div class="paymentStatus">
    <template v-if="showContents === 'loading'">
      読み込み中<span class="paymentStatus__loading"></span>
    </template>
    <template v-else-if="showContents === 'error'">
      読み込みに失敗しました。<br>
      お手数ですが、もう一度ログインしているかご確認ください。<br>
      <br>
      <base-button
        text="戻る"
        :href="`${envDomain}user/mypage`"
      />
    </template>
    <template v-else-if="showContents === 'success'">
      <!-- クレジットカード登録済みの場合 -->
      <template v-if="isRegistered">
        <dl class="paymentStatus__dl">
          <dt>カード番号</dt>
          <dd class="paymentStatus__cardId">{{ card.number }}</dd>
          <dt>カード有効期限</dt>
          <dd class="paymentStatus__expiration">{{ card.expirationMonth }}/20{{ card.expirationYear }}</dd>
        </dl>
      </template>
      <!-- クレジットカード未登録の場合 -->
      <template v-else>
        <div class="paymentStatus__text">クレジットカード情報が未登録です。</div>
      </template>
      <base-button
        :text="isRegistered ? '変更' : '登録'"
        :href="`/academy/change_payment/${academyAccessToken}`"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import BaseButton from '@/utvStore/components/Academy/partials/BaseButton'
import getAcademyEnvDomain from '@/utils/getAcademyEnvDomain'

export default {
  name: 'AcademyPaymentStatus',
  components: {
    BaseButton,
  },
  data() {
    return {
      showContents: 'loading',
      isRegistered: false,
      envDomain: getAcademyEnvDomain(),
    }
  },
  props: {
    userId: String,
    academyAccessToken: String,
  },
  computed: {
    ...mapState({
      card: state => state.payment.academy,
    }),
  },
  created() {
    this.getPaymentInfo()
  },
  methods: {
    //カード情報取得
    getPaymentInfo() {
      if (!this.userId) {
        setTimeout(() => {
          this.showContents = 'error'
        }, 3000)
        return false
      }
      this.$store.dispatch(type.GET_PAYMENT_INFO_ACADEMY, { userId: this.userId })
      .then(()=> {
        this.isRegistered = true
        })
      .catch((err)=>console.log('card-unregistered!'))
      .finally(() => { this.showContents = 'success' })
    },
    back() {
      history.back()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';

.paymentStatus {
  &__loading {
    &::before {
      content: '.';
      animation: loading 4s infinite;
      @keyframes loading {
        0% { content: '.'; }
        25% { content: '..'; }
        50% { content: '...'; }
        75% { content: '....'; }
      }
    }
  }
  &__dl {
    margin: 0 0 21px;
    > dt,
    > dd {}
    > dt {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: $academy_purple;
      margin: 20px 0 5px;
      &:first-child {
        margin-top: 0;
      }
    }
    > dd {
      margin: 0;
      &.paymentStatus__cardId {
        font-size: 15px;
        line-height: 1;
      }
      &.paymentStatus__expiration {
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
  &__text {
    font-size: 12px;
    line-height: 17px;
    text-align: justify;
    margin: 0 0 81px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/pages/PaymentStatus.vue